import { useDispatchContext } from '~hooks/useContext/useDispatchContext';
import { useStateContext } from '~hooks/useContext/useStateContext';
import { DispatchI } from '~models/Dispatch';
import { StateI } from '~models/State';

export const useContext = (): [StateI, DispatchI] => {
  return [useStateContext(), useDispatchContext()];
};
